import React, { useState } from "react";
import "./PEOPage.css";
import Navbar from "../components/navbar";
import BrochureForm from "../components/EnquiryForm";
import CTAButtons from "../components/sticky-button";
import ContactAdmissionsStrip from "../components/ContactAdmissionsStrip";
import Footer from "../components/Footer";
import PageHeader from "../about/PageHeader";
import {
    LuBookOpenCheck,
    LuBrain,
    LuChartLine,
    LuCodeXml,
    LuGraduationCap,
    LuMonitor,
    LuScale,
    LuSearch,
    LuUsersRound,
    LuWrench,
} from "react-icons/lu";

export default function PEOPage() {
    const [showForm, setShowForm] = useState(false);

    const peos = [
        { id: "PEO-1", icon: LuMonitor, text: "Develop secure and sustainable solutions using contemporary technologies to address real-world problems. " },
        { id: "PEO-2", icon: LuCodeXml, text: "Pursue lifelong learning and research-driven innovation to adapt to evolving technologies and professional opportunities." },
        { id: "PEO-3", icon: LuBookOpenCheck, text: "Demonstrate leadership, teamwork and ethical responsibility while contributing to professional and societal development. " },
        // { id: "PEO-4", icon: LuUsersRound, text: "To develop communication, teamwork, and leadership skills necessary to manage multidisciplinary projects and serve the society as responsible and ethical software professionals." }
    ];

    const pos = [
        { id: "PO-1", icon: LuBrain, title: "Foundation Knowledge", desc: "Apply knowledge of mathematics, programming logic and coding fundamentals for solution architecture and problem solving." },
        { id: "PO-2", icon: LuSearch, title: "Problem Analysis", desc: "Identify, review, formulate and analyse problems for primarily focussing on customer requirements using critical thinking frameworks." },
        { id: "PO-3", icon: LuCodeXml, title: "Design / Development of Solution", desc: "Design, develop and investigate problems with an innovative approach for solutions incorporating ESG/SDG goals." },
        { id: "PO-4", icon: LuWrench, title: "Modern Tool Usage", desc: "Select, adapt and apply modern computational tools such as development of algorithms with an understanding of limitations." },
        { id: "PO-5", icon: LuUsersRound, title: "Individual and Teamwork", desc: "Function and communicate effectively as an individual or a team leader in diverse and multidisciplinary groups using agile methodologies." },
        { id: "PO-6", icon: LuChartLine, title: "Project Management and Finance", desc: "Use the principles of project management such as scheduling, WBS and be conversant with the principles of Finance." },
        { id: "PO-7", icon: LuScale, title: "Ethics", desc: "Commit to professional ethics in managing software projects and learn to insulate customers from malware and cyber security threats." },
        { id: "PO-8", icon: LuGraduationCap, title: "Life-long Learning", desc: "Change management skills and the ability to learn, keep up with contemporary technologies and ways of working." }
    ];

    return (
        <>
            <Navbar setShowForm={setShowForm} />
            {showForm && <BrochureForm setShowForm={setShowForm} />}
            <CTAButtons />

            <PageHeader
                title="Program Educational Objectives (PEOs)"
                crumbs={[
                    { label: 'Home', href: '/' },
                    { label: 'Program Educational Objectives' },
                ]}
            />

            <main className="peo-page">
                <section className="peo-grid">
                    {peos.map((peo) => (
                        <article key={peo.id} className="peo-card">
                            <span className="peo-card-icon" aria-hidden="true">
                                <peo.icon />
                            </span>
                            <h2>{peo.id}</h2>
                            <p>{peo.text}</p>
                        </article>
                    ))}
                </section>

                <section className="program-outcomes" aria-label="Program outcomes">
                    <div className="po-heading">
                        <h2>Program Outcomes (PO's)</h2>
                        <p>By the end of the program, students will be able to:</p>
                    </div>

                    <div className="po-list">
                        {pos.map((po) => (
                            <article key={po.id} className="po-row">
                                <span className="po-badge">{po.id}</span>
                                <span className="po-icon" aria-hidden="true">
                                    <po.icon />
                                </span>
                                <div className="po-content">
                                    <h3>{po.title}</h3>
                                    <p>{po.desc}</p>
                                </div>
                            </article>
                        ))}
                    </div>
                </section>

            </main>

            <ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />
            <Footer />
        </>
    );
}
